/**
 * @file     index.ts
 * @purpose  Public barrel for the content subsystem, re-exports catalogs, messageRef helpers, resolveContent, types, and useResolvedContent.
 */
/**
 * Content + i18n maintenance note: If the public content-resolution surface changes here, update
 * `docs/architecture/content-i18n-architecture.md` in the same change.
 */

export * from './catalogs';
export * from './messageRef';
export * from './resolveContent';
export * from './types';
export * from './useResolvedContent';
